// Reference Data Sync API client (admin). Push a source reference table into
// many target databases. connection ids come from <select> (strings) → Number.
import { api } from './api.js';

const normTargets = (targets) => (targets || []).map((t) => ({ conn: Number(t.conn), db: t.db }));

// → { source: {table, pkColumns, columns, rowCount},
//     targets: [{conn, db, ok, error?, insert, update, delete, same, syncedColumns, droppedColumns}],
//     mode }
export const previewRefSync = (srcConn, srcDb, srcTable, mode, targets) =>
  api.post('/api/tools/refsync/preview', { srcConn: Number(srcConn), srcDb, srcTable, mode, targets: normTargets(targets) });

// → { targets: [{conn, db, ok, error?, inserted, updated, deleted}], mode }
export const applyRefSync = (srcConn, srcDb, srcTable, mode, targets, onError = 'continue') =>
  api.post('/api/tools/refsync/apply', { srcConn: Number(srcConn), srcDb, srcTable, mode, targets: normTargets(targets), onError });
